<template>
  <div>
    <v-dialog v-model="addFundsForms" max-width="980px">
      <template v-slot:activator="{on}">
        <v-btn small v-on="on" class="primary themed">Recharger du crédit</v-btn>
      </template>
      <v-card>
        <v-toolbar>
          <v-toolbar-title>Recharger du crédit</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-container fluid v-if="!success">
            <v-row>
              <v-col cols="12">
                <h2 class="subtitle">Quel montant voulez-vous recharger ?</h2>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4">
                <v-text-field v-model="amount" suffix="CHF"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <h2 class="subtitle mb-4">Vos information de paiement</h2>
                <stripe-elements
                  ref="elementsRef"
                  :pk="publishableKey"
                  :amount="amount*100"
                  @token="tokenCreated"
                  @loading="loading = $event"
                ></stripe-elements>
              </v-col>
            </v-row>
          </v-container>
          <v-containe v-else fluide>
            <v-row>
              <v-col cols="12">
                <h2 class="subtitle">Paiement reçu, merci pour votre confiance</h2>
              </v-col>
            </v-row>
          </v-containe>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            v-if="!success"
            small
            @click="submit"
            class="primary themed"
          >Payer {{$format.money(amount)}}</v-btn>
          <v-btn v-else @click="close()" class="themed">Ferme</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-btn
      text
      color="red"
      @click="$router.push('/profile/money-request')"
      v-if="waitingMoneyRequest.length>0"
    >{{waitingMoneyRequest.length}} Demande de fonds en attente</v-btn>
  </div>
</template>

<script>
import { StripeElements } from "vue-stripe-checkout";
import { mapActions, mapGetters } from "vuex";
import { STRIPE_PUBLIC } from "../../common/config-local";

export default {
  components: {
    StripeElements
  },
  data: () => ({
    success: false,
    addFundsForms: false,
    loading: false,
    amount: 100,
    publishableKey: STRIPE_PUBLIC,
    token: null,
    charge: null
  }),
  mounted() {
    this.initialize();
  },
  computed: {
    ...mapGetters("moneyRequest", ["moneyRequests"]),
    waitingMoneyRequest() {
      return this.moneyRequests.filter(request => request.status == "asked");
    }
  },
  methods: {
    initialize() {
      this.list();
    },
    submit() {
      this.$refs.elementsRef.submit();
    },
    tokenCreated(token) {
      this.token = token;
      // for additional charge objects go to https://stripe.com/docs/api/charges/object
      this.charge = {
        token: token.id,
        amount: this.amount,
        description: this.description
      };
      this.sendTokenToServer(this.charge).then(() => {
        this.success = true;
        this.$emit("addFunds");
      });
    },
    close() {
      this.addFundsForms = false;
    },
    ...mapActions("stripes", ["sendTokenToServer"]),
    ...mapActions("moneyRequest", ["list"])
  }
};
</script>

<style>
</style>